import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { CompositeFilterDescriptor, FilterDescriptor } from '@progress/kendo-data-query';

@Component
export default class GridfilterMultiselect extends Vue {
    @Prop({ default: () => '' }) public field: string;
    @Prop({ default: () => [] }) public options: string[];
    @Prop({ default: () => null }) public filter: CompositeFilterDescriptor;
    @Prop() public defaultSelected?: string[];
    public selected: string[] = [];
    public isVisible: boolean = false;

    public mounted() {
        const selectedState = sessionStorage.getItem(`multi-${this.field}`);

        if (this.defaultSelected && !selectedState) {
            this.selected = this.defaultSelected;
            this.input();
        } else if (selectedState) {
            this.selected = selectedState.split(',');
            this.input();
        }
    }

    public input() {
        const key = `multi-${this.field}`;
        if (!this.filter) {
            return;
        }
        this.filter.filters = this.filter.filters.filter((f: any) => {
            return f.field !== this.field;
        });

        if (this.selected.length > 0) {
            const multiselectFilter = { logic: 'or', filters: [], field: this.field } as CompositeFilterDescriptor;
            this.selected.forEach((value) => {
                multiselectFilter.filters.push({
                    operator: 'contains',
                    field: this.field,
                    value,
                    key,
                } as FilterDescriptor);
            });
            this.filter.filters.push(multiselectFilter);
        }

        sessionStorage.setItem(`multi-${this.field}`, this.selected.join(','));
    }

    public toggle() {
        this.isVisible = !this.isVisible;
    }
}
